import client from './index'
import store from '@/store'

// Common
const downloadFile = (url) => client['api'].get(url, { responseType: 'blob'})
// Internship
const getDataInternship = (data) => client['api'].get(`internship`, {params: data})
const storeInternship = (data) => client['api'].post(`internship`, data, {"Content-Type": "multipart/form-data",  onUploadProgress: progressEvent => {
    let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    store.dispatch('setLoading',percentCompleted)
  }})
const updateInternship = (id,data) => client['api'].post(`internship/${id}`, data, {"Content-Type": "multipart/form-data",  onUploadProgress: progressEvent => {
  let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
  store.dispatch('setLoading',percentCompleted)
}})
const destroyInternship = (id) => client['api'].delete(`internship/${id}`)

const kaprodiVerify = (id,data) => client['api'].post(`/internship/verify/kaprodiVerify/${id}`, data)
const administratorVerify = (id,data) => client['api'].post(`/internship/verify/administratorVerify/${id}`, data)
const lectureVerify = (id) => client['api'].post(`/internship/verify/lectureVerify/${id}`)
// Rejection
const getDataInternshipRejection = (internships_id,data) => client['api'].get(`internshiprejection/${internships_id}`, {params: data}, )
const storeInternshipRejection = (data) => client['api'].post(`internshiprejection`, data, {"Content-Type": "multipart/form-data",  onUploadProgress: progressEvent => {
    let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    store.dispatch('setLoading',percentCompleted)
  }})
const updateInternshipRejection = (id,data) => client['api'].post(`internshiprejection/${id}`, data, {"Content-Type": "multipart/form-data",  onUploadProgress: progressEvent => {
    let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    store.dispatch('setLoading',percentCompleted)
  }})
const destroyInternshipRejection = (id) => client['api'].delete(`internshiprejection/${id}`)
const getDataRejection = (data) => client['api'].get(`internship/rejectiondata`, {params: data})
const kaprodiVerifyInternshipRejection = (id,data) => client['api'].post(`/internshiprejection/verify/kaprodiVerify/${id}`, data)

export {
    downloadFile,
    getDataInternship,
    storeInternship,
    updateInternship,
    destroyInternship,
    getDataInternshipRejection,
    storeInternshipRejection,
    updateInternshipRejection,
    destroyInternshipRejection,
    kaprodiVerify,
    administratorVerify,
    lectureVerify,
    getDataRejection,
    kaprodiVerifyInternshipRejection
}